"use client"

interface FloatingShareButtonProps {
  onClick?: () => void
  children: React.ReactNode
}

export const FloatingShareButton = (props: FloatingShareButtonProps) => {
  return (
    <button
      onClick={props.onClick}
      className="bg-white group flex size-12 items-center justify-center self-stretch rounded-full border border-[#A995D6]/20 bg-bg-1 shadow-[19px_11px_26.8px_0px_rgba(100,10,217,0.06)] transition-all duration-300 hover:border-[#A995D666] hover:shadow-[0px_9px_49.7px_0px_rgba(229,150,215,0.22),19px_11px_26.8px_0px_rgba(100,10,217,0.10)]">
      {props.children}
    </button>
  )
}
